/**
 * Gets a value from a nested object. Curried.
 *
 * Use: get( ['user', 'posts', 0, 'comments'] )( object )
 *
 * @see https://medium.com/javascript-inside/safely-accessing-deeply-nested-values-in-javascript-99bf72a0855a
 *
 * @param path Array
 * @param object
 */
export const get = p => o =>
	p.reduce( ( xs, x ) =>
	( xs && xs[ x ] ) ? xs[ x ] : null, o )
